import { MRT_ColumnDef, useMaterialReactTable, MaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, Clientes, RetAPI, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ThemeProvider, createTheme } from '@mui/material'
import { Tooltip } from 'react-tooltip'
import { useNavigate } from 'react-router-dom'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { ClientesService } from '../../Pages/Clientes/ClientesService'
import { Funcoes } from '../../Utils/Funcoes'
import { RiEdit2Fill } from 'react-icons/ri'
import { FaTrashAlt } from 'react-icons/fa'
import moment from 'moment'

type Props = {
    cliente: Clientes[],
    handleUpdateClienteList: () => void,
}

interface RowData {
    id: number,
    nome: string,
    nome_fantasia: string,
    endereco: string,
    bairro: string,
    numero: number,
    cep: string,
    id_cidade: number,
    nome_cidade: string,
    uf: string,
    tipo_pessoa: string,
    cnpj_cpf: string,
    ie_rg: string,
    complemento: string,
    observacao: string,
    ativo: string,
    dt_cadastro: string,
}

type VisibilityState = Record<string, boolean>

export const GridCliente = React.memo(({ cliente, handleUpdateClienteList }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_cliente")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_cliente") || '')
                : {
                    acao: true,
                    nome: true,
                    nome_fantasia: true,
                    tipo_pessoa: false,
                    cnpj_cpf: true,
                    ie_rg: false,
                    ativo: false,
                    observacao: false,
                    cep: false,
                    endereco: false,
                    bairro: false,
                    numero: false,
                    complemento: false,
                    nome_cidade: true,
                    uf: true,
                    dt_cadastro: false
                }
        )
    }, [])

    const [idCliente, setIdCliente] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [clientes, setClientes] = useState<Clientes[]>([])
    const [nomeCliente, setNomeCliente] = useState("")

    //const [modal_dados_cliente_visible, setModal_Dados_Cliente_Visible] = useState(false)

    let user = useSelector(state => selectUser(state))

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setClientes(cliente)
    }, [cliente])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_cliente", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await ClientesService.Delete(idCliente, motivo, senha)
            Inputfocus()

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Cliente excluído com sucesso`)

                handleUpdateClienteList()

                //const cliente = await ClientesService.Filter('', '', '')
                //setClientes(cliente)
                //setModalShow(false)

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
                //setModalShow(false)
            }

        } catch (error) {

            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir o cliente. Por favor, tente novamente`)
        }

    }, [idCliente])

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeCliente("")
        }

        /*
        let menuFiltro = document.getElementById("divMenuFiltroCli") as HTMLDivElement

        let menuInputs = document.getElementById("divInputsCli") as HTMLDivElement

        let bodySearchUF = document.getElementById("bodySearchBox-uf") as HTMLDivElement

        let bodySearchCidade = document.getElementById("bodySearchBox-cidade") as HTMLDivElement


        if (menuFiltro) {

            menuFiltro.classList.add("max-h-[1000px]")
            menuFiltro.classList.remove("max-h-[0px]")

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 100)

            menuInputs.classList.remove("invisible")

        }
        */

    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeCliente("")
    }, [])

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa_cliente")
        inputElement?.focus()
    }

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- CODIGO SEM USO --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    /*
    const abrirModalDadosCliente = () => {
        //setModal_Dados_Cliente_Visible(true)
    }

    const fecharModalDadosCliente = () => {
        //setModal_Dados_Cliente_Visible(false)
    }
    */


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaClienteEdit = (id: number) => {
        navigate(`/cliente/edit/${id}`)
    }


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const mapTipoPessoa = (tipo: string): JSX.Element => {
        return <span>{tipo === 'F' ? 'Física' : 'Jurídica'}</span>
    }

    const mapTipoAtivo = (ativo: string): JSX.Element => {
        return <span>{ativo === 'S' ? 'Sim' : 'Não'}</span>
    }

    const colunas = useMemo<MRT_ColumnDef<Clientes>[]>(() => [

        {
            accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: true, size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                const navegar = () => {
                    navegarTelaClienteEdit(rowData.id)
                }

                const handleExcluirClick = () => {

                    const timerExcluir = setTimeout(() => {

                        setIdCliente(rowData.id)
                        setNomeCliente(rowData.nome)
                        setModalShow(true)

                        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

                        if (divPerfil) {
                            divPerfil.classList.add('hidden')
                        }

                        let menuFiltro = document.getElementById("divMenuFiltroCli") as HTMLDivElement
                        let menuInputs = document.getElementById("divInputsCli") as HTMLDivElement
                        let bodySearchUF = document.getElementById("bodySearchBox-uf") as HTMLDivElement
                        let bodySearchCidade = document.getElementById("bodySearchBox-cidade") as HTMLDivElement

                        if (menuFiltro) {

                            bodySearchUF.classList.remove("visible")
                            bodySearchCidade.classList.remove("visible")

                            menuInputs.classList.add("invisible")

                            const timer = setTimeout(() => {
                                menuFiltro.classList.remove("max-h-[1000px]")
                                menuFiltro.classList.add("max-h-[0px]")
                                Inputfocus()
                                clearTimeout(timer)
                            }, 100)
                        }

                        clearTimeout(timerExcluir)
                    }, 0)

                }

                return (

                    <>
                        <div className={`flex justify-start w-full`}>

                            <button
                                onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                          bg-sky-500`}>
                                <RiEdit2Fill size="20px" />
                                <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                    <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                                </Tooltip>
                            </button>

                            <button
                                onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                          bg-red-500 ml-2`} >
                                <FaTrashAlt size="18px" />
                                <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed"  >
                                    <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                                </Tooltip>
                            </button>

                        </div>
                    </>

                )
            }
        },

        {
            accessorKey: 'nome', visibleInShowHideMenu: true, header: 'Razão Social / Nome', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nome ? rowData.nome : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'nome_fantasia', visibleInShowHideMenu: true, header: 'Nome Fantasia / Apelido', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nome_fantasia ? rowData.nome_fantasia : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'tipo_pessoa', visibleInShowHideMenu: true, header: 'Pessoa', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData
                const tipoPessoa: string = rowData.tipo_pessoa

                return mapTipoPessoa(tipoPessoa)
            }
        },

        {
            accessorKey: 'cnpj_cpf', visibleInShowHideMenu: true, header: 'CPF / CNPJ', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cnpj_cpf ? Funcoes.FormatDoc(rowData.cnpj_cpf.toString()) : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'ie_rg', visibleInShowHideMenu: true, header: 'Insc. Estadual / RG', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.ie_rg ? rowData.ie_rg : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'ativo', visibleInShowHideMenu: true, header: 'Ativo', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {
                const rowData = cell.row.original as RowData
                const tipoAtivo: string = rowData.ativo

                return mapTipoAtivo(tipoAtivo)
            }
        },

        {
            accessorKey: 'observacao', visibleInShowHideMenu: true, header: 'Observação', size: 400, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.observacao ? rowData.observacao : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'cep', visibleInShowHideMenu: true, header: 'Cep', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cep ? Funcoes.FormatCep(rowData.cep.toString()) : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'endereco', visibleInShowHideMenu: true, header: 'Logradouro', size: 400, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.endereco ? rowData.endereco : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'bairro', visibleInShowHideMenu: true, header: 'Bairro', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.bairro ? rowData.bairro : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'numero', visibleInShowHideMenu: true, header: 'Número', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.numero ? rowData.numero : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'complemento', visibleInShowHideMenu: true, header: 'Complemento', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.complemento ? rowData.complemento : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'nome_cidade', visibleInShowHideMenu: true, header: 'Cidade', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nome_cidade ? rowData.nome_cidade : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'uf', visibleInShowHideMenu: true, header: 'Estado', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.uf ? rowData.uf : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'dt_cadastro', visibleInShowHideMenu: true, header: 'Data de Cadastro', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_cadastro ? moment(rowData.dt_cadastro).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        }

    ], [])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TABLE --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const table = useMaterialReactTable({
        columns: colunas,
        data: clientes,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,
        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },

            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: true,
        enableColumnFilters: false,
        enableHiding: true,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>
            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir o cliente - ${nomeCliente || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

            {/*
            <ModalDadosCliente
                visible={modal_dados_cliente_visible}
                closeModalEvent={fecharModalDadosCliente}
                idCli={idCliente.toString()}
            />
            */}

        </>
    )
})